import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Localización del Punto Ciego',
    desc: 'A través de las preguntas de diagnóstico del RMA, pondremos luz sobre la creencia raíz que está saboteando tu cuenta bancaria hoy. Te darás cuenta de que la razón por la que no ganas más no es técnica, es una protección de tu ego.'
  }, {
    num: '2',
    title: 'Neutralización de la Identidad de Escasez',
    desc: "Aprenderás a 'matar' a tu viejo yo. El que tiene miedo, el que duda, el que se siente pequeño. No lo harás con lógica, lo harás cambiando tu estado biológico."
  }, {
    num: '3',
    title: 'Sintonización de la Frecuencia de Riqueza',
    desc: 'Configuraremos tu nuevo Yo. El que toma decisiones con certeza, el que invierte con confianza y el que recibe el dinero con gratitud. Verás cómo, al cambiar tú, el mercado empieza a responderte de manera diferente.'
  }];
  return <section className="py-16 md:py-[80px] px-4" data-id="element-90">
      <div className="max-w-[800px] mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-92">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-93">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-94"></span>
            El Proceso
          </div>
          <h2 className="font-heading text-3xl md:text-[40px] font-black leading-[1.1] text-white uppercase tracking-tight" data-id="element-95">
            EL CAMINO A LA <span className="text-gold" data-id="element-96">TRANSFORMACIÓN</span>
          </h2>
        </motion.div>

        <motion.div className="flex flex-col gap-4" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-97">
          {steps.map((step, index) => <motion.div key={index} variants={itemVariants} className="overflow-hidden rounded-lg border border-border bg-surface" data-id="element-98">
              <div className="flex items-center gap-2 border-b border-border bg-surface-light px-[18px] py-3" data-id="element-99">
                <div className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-gold text-[10px] font-black text-black" data-id="element-100">
                  {step.num}
                </div>
                <div className="font-heading text-[10px] font-bold tracking-[2px] text-gold uppercase" data-id="element-101">
                  Paso {step.num}
                </div>
              </div>
              <div className="px-[18px] py-[18px]" data-id="element-102">
                <h3 className="mb-2 font-heading text-[15px] font-black uppercase tracking-[1px] text-white" data-id="element-103">
                  {step.title}
                </h3>
                <div className="text-[13px] leading-[1.75] text-text-card" data-id="element-104">
                  {step.desc}
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}